import { DeviceLocation } from './locationService';
import { locationService } from './locationService';

export interface DeviceInfo {
  userAgent: string;
  platform: string;
  language: string;
  screenResolution: string;
  timeZone: string;
  ipAddress?: string;
  deviceId: string;
  appVersion: string;
  location?: DeviceLocation | null;
  lastKnownLocation?: DeviceLocation | null;
}
const getClientIP = async (): Promise<string | undefined> => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.warn('Could not get client IP:', error);
    return undefined;
  }
};

const getDeviceId = (): string => {
  if (typeof window === 'undefined') return 'server-device';
  
  let deviceId = localStorage.getItem('device_id');
  if (!deviceId) {
    deviceId = 'dev_' + Math.random().toString(36).substr(2, 9);
    try {
      localStorage.setItem('device_id', deviceId);
    } catch (error) {
      console.error('Error saving device ID:', error);
    }
  }
  return deviceId;
};

export const getDeviceInfo = async (): Promise<DeviceInfo> => {
  let ipAddress: string | undefined;
  let location: DeviceLocation | null = null;
  
  try {
    const [ip, currentLocation] = await Promise.all([
      getClientIP(),
      locationService.getCurrentLocation()
    ]);
    ipAddress = ip;
    location = currentLocation;
  } catch (error) {
    console.error('Error getting device info:', error);
  }

  const baseInfo: DeviceInfo = {
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'server',
    platform: typeof navigator !== 'undefined' ? navigator.platform : 'server',
    language: typeof navigator !== 'undefined' ? navigator.language : 'en-US',
    screenResolution: typeof window !== 'undefined' 
      ? `${window.screen.width}x${window.screen.height}` 
      : '0x0',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ipAddress,
    deviceId: getDeviceId(),
    appVersion: process.env.REACT_APP_VERSION || '1.0.0',
    location,
    lastKnownLocation: locationService.getLastKnownLocation()
  };

  // Store last known device info for offline use
  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem('last_device_info', JSON.stringify(baseInfo));
    } catch (error) {
      console.error('Error caching device info:', error);
    }
  }

  return baseInfo;
};

export const getLastKnownDeviceInfo = (): DeviceInfo | null => {
  if (typeof window === 'undefined') return null;
  
  try {
    const cached = localStorage.getItem('last_device_info');
    return cached ? JSON.parse(cached) : null;
  } catch (error) {
    console.error('Error getting cached device info:', error);
    return null;
  }
};

